import { createContext, useEffect, useState } from "react";

export const FlagsmithContext = createContext();

export const FlagsmithProvider = ({state, children}) => {
  
  const [values, setValues] = useState({})

  const updateValues = async () => {
    const promise = await state;
    setValues(promise)
  }

  useEffect(() => {
      updateValues();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state])

  return (
    <FlagsmithContext.Provider value={values}>
      {children}
    </FlagsmithContext.Provider>
  );

}
